import React from "react";
import { Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import Sidebar from "../../SideBar";
import axios from "axios";
import { useState, useEffect } from "react";
import Swal from "sweetalert2";
import HeaderName from "../../HeaderName";
import { API_URL } from "../../../../api";
// import { useSelector } from 'react-redux'

function LabServiceRegister() {
  const token = localStorage.getItem("token");
  const url = API_URL();

  const api = axios.create({
    baseURL: url,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  //Doctor
  const [branch, setBranch] = useState("");
  const [name, setName] = useState("");
  const [code, setCode] = useState("");
  const [special, setSpecial] = useState("");
  const [treatmentUnitMain, setTreatmentUnitMain] = useState("");
  const [commission, setCommission] = useState("");
  const [schedule, setSchedule] = useState("");

  //Therapist
  const [tBranch, setTBranch] = useState("");
  const [tName, setTName] = useState("");
  const [tCode, setTCode] = useState("");
  const [tSpecial, setTSpecial] = useState("");
  const [tTreatmentUnitMain, setTTreatmentUnitMain] = useState("");
  const [tCommission, setTCommission] = useState("");
  const [tSchedule, setTSchedule] = useState("");

  //Nurse
  const [nBranch, setNBranch] = useState("");
  const [nName, setNName] = useState("");
  const [nCode, setNCode] = useState("");
  const [nSpecial, setNSpecial] = useState("");
  const [nTreatmentUnitMain, setNTreatmentUnitMain] = useState("");
  const [nCommission, setNCommission] = useState("");
  const [nSchedule, setNSchedule] = useState("");

  const [showRelatedDoc, setShowRelatedDoc] = useState(true);
  const [showTherapist, setShowTherapist] = useState(false);
  const [showNurse, setShowNurse] = useState(false);

  const [doctorLists, setDoctorLists] = useState([]);
  const [therapistLists, setTherapistLists] = useState([]);
  const [nurseLists, setNurseLists] = useState([]);

  const [branchLists, setBranchLists] = useState([]);

  // const url = 'http://backendcherryk.kwintechnologykw11.com:4000/api'

  const validateCommission = (value) => {
    if (value === "" || value === null) {
      Swal.fire({
        title: "Error",
        text: "Commission is required",
        icon: "error",
        timer: 2000,
        showConfirmButton: false,
      });
      return false;
    }

    if (value < 0 || value > 100) {
      Swal.fire({
        title: "Invalid Commission",
        text: "Commission must be between 0 and 100",
        icon: "error",
        timer: 2000,
        showConfirmButton: false,
      });
      return false;
    }

    return true;
  };

  //Doctor create
  const DoctorCreate = (event) => {
    if (!validateCommission(commission)) return;
    const data = {
      name: name,
      code: code,
      treatmentUnitMain: treatmentUnitMain,
      commissionPercent: commission,
      schedule: schedule,
      speciality: special,
    };

    // alert(JSON.stringify(data))
    const config = {
      headers: { "Content-Type": "application/json" },
    };
    api
      .post("doctor", data, config)
      .then(function (response) {
        setDoctorLists([...doctorLists, response.data.data]);
        Swal.fire({
          title: "Success",
          text: "successfully Registered!",
          icon: "success",
          showConfirmButton: false,
          timer: 2000,
        });
        document.getElementById("name").value = "";
        document.getElementById("com").value = "";
        document.getElementById("spe").value = "";
        document.getElementById("unit").value = "";
        document.getElementById("sche").value = "";
      })
      .catch(function (err) {
        Swal.fire({
          title: "Error",
          text: "Something Wrong",
          icon: "error",
          showConfirmButton: false,
          timer: 2000,
        });
      });
  };

  //Therapist create
  const TherapistCreate = (event) => {
    if (!validateCommission(commission)) return;
    const data = {
      name: tName,
      code: tCode,
      treatmentUnitMain: tTreatmentUnitMain,
      commissionPercent: tCommission,
      schedule: tSchedule,
      speciality: tSpecial,
    };

    // alert(JSON.stringify(data))
    const config = {
      headers: { "Content-Type": "application/json" },
    };
    api
      .post("therapist", data, config)
      .then(function (response) {
        setTherapistLists([...therapistLists, response.data.data]);
        Swal.fire({
          title: "Success",
          text: "successfully Registered!",
          icon: "success",
          showConfirmButton: false,
          timer: 2000,
        });

        // document.getElementById('name').value = ''
        // document.getElementById('com').value = ''
        // document.getElementById('spe').value = ''
        // document.getElementById('unit').value = ''
        // document.getElementById('sche').value = ''
      })
      .catch(function (err) {
        Swal.fire({
          title: "Error",
          text: "Something Wrong",
          icon: "error",
          showConfirmButton: false,
          timer: 2000,
        });
      });
  };

  //Nurse
  const NurseCreate = (event) => {
    if (!validateCommission(commission)) return;
    const data = {
      name: nName,
      code: nCode,
      treatmentUnitMain: nTreatmentUnitMain,
      commission: nCommission,
      schedule: nSchedule,
      speciality: nSpecial,
    };

    // alert(JSON.stringify(data))
    const config = {
      headers: { "Content-Type": "application/json" },
    };
    api
      .post("nurse", data, config)
      .then(function (response) {
        setNurseLists([...nurseLists, response.data.data]);
        Swal.fire({
          title: "Success",
          text: "Successfully Nurse Registered!",
          icon: "success",
          showConfirmButton: false,
          timer: 2000,
        });

        // document.getElementById('name').value = ''
        // document.getElementById('com').value = ''
        // document.getElementById('spe').value = ''
        // document.getElementById('unit').value = ''
        // document.getElementById('sche').value = ''
      })
      .catch(function (err) {
        Swal.fire({
          title: "Error",
          text: "Something Wrong",
          icon: "error",
          showConfirmButton: false,
          timer: 2000,
        });
      });
  };

  useEffect(() => {}, []);
  return (
    <div classNameName="App">
      <div className="wrapper">
        <div>
          {/* <!-- Content Header (Page header) --> */}
          <div className="content-header">
            <div className="container-fluid px-2">
              <div className="row mb-2">
                <div className="col-sm-12">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/doctor">
                        <i>
                          <FaArrowLeft />
                        </i>
                      </Link>
                    </li>
                    <li className="breadcrumb-item active mt-1">
                      Doctor / Nurse Aid Register
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          {/* <!-- Main content --> */}
          <section className="content" style={{ paddingBottom: "1.5rem" }}>
            <div className="container-fluid px-4">
              {/* <!-- Small boxes (Stat box) --> */}
              <div class="card">
                <div class="card-body p-b-0">
                  {/* @if($com == null) */}

                  {/* @csrf */}

                  <div className="form-group">
                    <div className="row">
                      <div className="col-md-4">
                        <label>ReferDoctor</label>&nbsp;
                        <input
                          type="radio"
                          id="doccl"
                          name="doccl"
                          onChange={(e) => {
                            setShowRelatedDoc(true);
                            setShowNurse(false);

                            setShowTherapist(false);
                          }}
                        />
                      </div>
                      {/* <div className="col-md-4">
                        <label>Clinic</label>&nbsp;
                        <input
                          type="radio"
                          id="doccl"
                          name="doccl"
                          value="Clinic"
                          onChange={(e) => {
                            setSelection(e.target.value);
                            setShowRelatedDoc(false);
                          }}
                        />
                      </div> */}
                      {/* <div className='col-md-4'>
                        <label>Nurse Aid</label>&nbsp;
                        <input
                          type='radio'
                          id='doccl'
                          name='doccl'
                          onClick={e => {
                            setShowRelatedDoc(false)
                            setShowNurse(true)
                            setShowTherapist(false)
                          }}
                        />
                      </div> */}
                      <div className="col-md-4">
                        <label>Therapist</label>&nbsp;
                        <input
                          type="radio"
                          id="doccl"
                          name="doccl"
                          value="Pathologist"
                          className=""
                          onClick={(e) => {
                            setShowRelatedDoc(false);
                            setShowNurse(false);

                            setShowTherapist(true);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  {/* {showNurse && (
                    <>
                      <div className='form-group'>
                        <label className='control-label'>Name</label>
                        <input
                          type='text'
                          className='form-control'
                          name='company_address'
                          id='name'
                          onChange={e => setNName(e.target.value)}
                        />
                      </div>
                      <div className='form-group'>
                        <label className='control-label'>Password</label>
                        <input
                          type='text'
                          className='form-control'
                          name='company_address'
                          id='name'
                          placeholder='eg : name123'
                          onChange={e => setNCode(e.target.value)}
                        />
                      </div>
                      <div className='form-group'>
                        <label className='control-label'>Position</label>
                        <input
                          type='text'
                          className='form-control'
                          id='spe'
                          name='company_contact'
                          onChange={e => setNSpecial(e.target.value)}
                        />
                      </div>
                      <div className='form-group'>
                        <label className='control-label'>Treatment Type</label>
                        <input
                          type='email'
                          className='form-control'
                          id='unit'
                          name='company_email'
                          onChange={e => setNTreatmentUnitMain(e.target.value)}
                        />
                      </div>
                     
                      <div className='form-group'>
                        <label className='control-label'>Commission</label>

                        <input
                          type='number'
                          className='form-control'
                          id='com'
                          onChange={e => setNCommission(e.target.value)}
                        />
                      </div>
                      <div className='form-group'>
                        <label className='control-label'>Joined Date</label>

                        <input
                          type='date'
                          className='form-control'
                          id='sche'
                          onChange={e => setNSchedule(e.target.value)}
                        />
                      </div>
                      <div></div>
                      <br />
                      <div className='row'>
                        <div className='col-md-6'>
                          <div className='row'>
                            <div className=' col-md-9'>
                              <button
                                type='submit'
                                className='btn btn-primary'
                                onClick={NurseCreate}
                              >
                                Nurse Create
                              </button>
                              &nbsp;
                              <button
                                type='button'
                                className='btn btn-danger'
                                data-dismiss='modal'
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )} */}
                  {showRelatedDoc && (
                    <>
                      <div className="form-group">
                        <label className="control-label">Name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="company_address"
                          id="name"
                          onChange={(e) => setName(e.target.value)}
                        />
                      </div>
                      <div className="form-group">
                        <label className="control-label">Password</label>
                        <input
                          type="text"
                          className="form-control"
                          name="company_address"
                          id="name"
                          placeholder="eg : name123"
                          onChange={(e) => setCode(e.target.value)}
                        />
                      </div>
                      <div className="form-group">
                        <label className="control-label">Position</label>
                        <input
                          type="text"
                          className="form-control"
                          id="spe"
                          name="company_contact"
                          onChange={(e) => setSpecial(e.target.value)}
                        />
                      </div>
                      <div className="form-group">
                        <label className="control-label">Treatment Type</label>
                        <input
                          type="email"
                          className="form-control"
                          id="unit"
                          name="company_email"
                          onChange={(e) => setTreatmentUnitMain(e.target.value)}
                        />
                      </div>
                      {/* <div className="form-group">
                      <div className="row  mt-3">
                        <div className="col-md-4">
                          <label>Amount</label>&nbsp;
                          <input
                            type="radio"
                            id="amoper"
                            name="amoper"
                            value="Amount"
                            onChange={(e) => setValueType(e.target.value)}
                          />
                        </div>
                        &nbsp;&nbsp;&nbsp;
                        <div className="col-md-4">
                          <label>%</label>&nbsp;
                          <input
                            type="radio"
                            id="amoper"
                            name="amoper"
                            value="Percent"
                            onChange={(e) => setValueType(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                    */}
                      <div className="form-group">
                        <label className="control-label">Commission</label>

                        <input
                          type="number"
                          className="form-control"
                          id="com"
                          onChange={(e) => setCommission(e.target.value)}
                        />
                      </div>
                      <div className="form-group">
                        <label className="control-label">Joined Date</label>

                        <input
                          type="date"
                          className="form-control"
                          id="sche"
                          onChange={(e) => setSchedule(e.target.value)}
                        />
                      </div>
                      <div></div>
                      <br />
                      <div className="row">
                        <div className="col-md-6">
                          <div className="row">
                            <div className=" col-md-9">
                              <button
                                type="submit"
                                className="btn btn-primary"
                                onClick={DoctorCreate}
                              >
                                Doctor Create
                              </button>
                              &nbsp;
                              <button
                                type="button"
                                className="btn btn-danger"
                                data-dismiss="modal"
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  {showTherapist && (
                    <>
                      <div className="form-group">
                        <label className="control-label">Name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="company_address"
                          id="name"
                          onChange={(e) => setTName(e.target.value)}
                        />
                      </div>
                      <div className="form-group">
                        <label className="control-label">Password</label>
                        <input
                          type="text"
                          className="form-control"
                          name="company_address"
                          id="name"
                          placeholder="eg : name123"
                          onChange={(e) => setTCode(e.target.value)}
                        />
                      </div>
                      <div className="form-group">
                        <label className="control-label">Position</label>
                        <input
                          type="text"
                          className="form-control"
                          id="phone"
                          name="company_contact"
                          onChange={(e) => setTSpecial(e.target.value)}
                        />
                      </div>
                      <div className="form-group">
                        <label className="control-label">Treatment Type</label>
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          name="company_email"
                          onChange={(e) =>
                            setTTreatmentUnitMain(e.target.value)
                          }
                        />
                      </div>
                      {/* <div className="form-group">
                      <div className="row  mt-3">
                        <div className="col-md-4">
                          <label>Amount</label>&nbsp;
                          <input
                            type="radio"
                            id="amoper"
                            name="amoper"
                            value="Amount"
                            onChange={(e) => setValueType(e.target.value)}
                          />
                        </div>
                        &nbsp;&nbsp;&nbsp;
                        <div className="col-md-4">
                          <label>%</label>&nbsp;
                          <input
                            type="radio"
                            id="amoper"
                            name="amoper"
                            value="Percent"
                            onChange={(e) => setValueType(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                    */}
                      <div className="form-group">
                        <label className="control-label">Commission</label>

                        <input
                          type="number"
                          className="form-control"
                          onChange={(e) => setTCommission(e.target.value)}
                        />
                      </div>
                      <div className="form-group">
                        <label className="control-label">Joined Date</label>

                        <input
                          type="date"
                          className="form-control"
                          onChange={(e) => setTSchedule(e.target.value)}
                        />
                      </div>
                      <div></div>
                      <br />
                      <div className="row">
                        <div className="col-md-6">
                          <div className="row">
                            <div className=" col-md-9">
                              <button
                                type="submit"
                                className="btn btn-primary"
                                onClick={TherapistCreate}
                              >
                                Therapist Create
                              </button>
                              &nbsp;
                              <button
                                type="button"
                                className="btn btn-danger"
                                data-dismiss="modal"
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>

              {/* <!-- /.row (main row) --> */}
            </div>
            {/*<!-- /.container-fluid --> */}
          </section>
          {/* <!-- /.content --> */}
        </div>
        {/* <!-- /.content-wrapper --> */}
        {/* <!-- Control Sidebar --> */}
        <aside className="control-sidebar control-sidebar-dark">
          {/* <!-- Control sidebar content goes here --> */}
        </aside>
        {/* <!-- /.control-sidebar --> */}
      </div>
      {/* <!-- ./wrapper --> */}
    </div>
  );
}
export default LabServiceRegister;
